<app-shared-calendar
  [config]="calendarConfig"
  [events]="previewEvents"
  [expandedDayEvents]="expandedDayEvents"
  [expandedDayKey]="expandedDayKey"
  [todayEvents]="todayEvents"
  [isLoadingEvents]="isLoadingAllEvents"
  [isLoadingTodayEvents]="isLoadingTodayEvents"
  [expandedDayLoadingKey]="expandedDayLoadingKey"
  [todayPage]="todayPage"
  [defaultInterval]="defaultInterval"
  [disabledIntervals]="disabledIntervals"
  [disablePastDrops]="true"
  (eventClick)="onEventClick($event)"
  (eventDrop)="onEventDrop($event)"
  (filterChange)="onFilterChange($event)"
  (searchChange)="onSearchChange($event)"
  (dateFilterChange)="onDateFilterChange($event)"
  (dateChange)="onDateChange($event)"
  (monthDayExpand)="onMonthDayExpand($event)"
  (todayScrolled)="onTodayScrollDown()">
  <app-account-filter headerActions [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>
</app-shared-calendar>